<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>Writing a book with another person, even your best friend, takes courage and commitment. It’s a testament to our long-standing and deep friendship and a deep commitment to collaboration that helped us bring this book into existence. We would like to dedicate this book to friendship, to the fundamental importance of love, to the power of maintaining a sense of humour and to the magical wonder of divine help and support.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?77b36d70